module.exports = __webpack_public_path__ + "static/img/icon_star.2afc01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/votefriend/images/icon_star.png
// module id = 2976
// module chunks = 1